<template>
  <!-- InvoiceToEAS -->
  <el-tab-pane label="InvoiceToEAS">
    <div>
      <div class="row">
        <div class="col-sm-12">
          <el-card>
            <h4 style="color: #3b291d">InvoiceToEAS =>
              <!-- <span v-if="dcName === 'hk'" style="color: red">{{ dcName }}</span>
              <span v-else style="color:blue">{{ dcName }}</span> -->
              <el-switch v-model="searchKey.SendDCName" :disabled="!useAuthority.bHasRole('SuperAdmin')" class="ml-2"
                inline-prompt size="large" style="--el-switch-on-color:red ; --el-switch-off-color: blue"
                active-text="hk" active-value="hk" inactive-text="hktest" inactive-value="hktest" />
            </h4>
            <!-- Start search part -->

            <hr />
            <div class="row">

              <div v-if="useAuthority.bHasRole('SuperAdmin')" class="col-sm-1">
                <base-input label="DcName" :clearable="true">
                  <el-select v-model="searchKey.dcName" class="select-primary" filterable size="large"
                    placeholder="DcName">
                    <el-option label="hk" value="hk"> </el-option>
                    <el-option label="hktest" value="hktest"> </el-option>
                  </el-select>
                </base-input>
              </div>

              <div class="col-sm-2">
                <base-input label="CreateDate" class="range-picker">
                  <el-date-picker type="daterange" placeholder="Date" v-model="searchKey.CreateDateList"
                    class="form-control" value-format="YYYY-MM-DD" format="DD/MM/YYYY">
                  </el-date-picker>
                </base-input>
              </div>

              <div class="col-sm-2">
                <base-input label="InvoiceNo">
                  <el-input placeholder="InvoiceNo" clearable style="
                      border: 1px solid hsl(0, 0%, 5%);
                      border-radius: 5px;
                      --el-input-focus-border-color: #f0f3f7;
                    " v-model="searchKey.contentNumber"></el-input>
                </base-input>
              </div>

              <div class="col-sm-2">
                <base-input label="Result" :clearable="true">
                  <el-select v-model="searchKey.result" class="select-primary" filterable size="large"
                    placeholder="Result">
                    <el-option label="all" value=""> </el-option>
                    <el-option label="fail" value="fail"> </el-option>
                    <el-option label="ok" value="ok"> </el-option>
                  </el-select>
                </base-input>
              </div>



              <div class="col-sm-2">
                <base-input label="Message">
                  <el-input placeholder="Message" clearable style="
                      border: 1px solid hsl(0, 0%, 5%);
                      border-radius: 5px;
                      --el-input-focus-border-color: #f0f3f7;
                    " v-model="searchKey.returnData"></el-input>
                </base-input>
              </div>
            </div>

            <div class="row">

              <div class="col-sm-2">
                <base-input label="Message" :clearable="true">
                  <el-select v-model="searchKey.returnData" class="select-primary" filterable size="large"
                    placeholder="Message">
                    <el-option label="" value=""> </el-option>
                    <el-option label="找不到对应的客户" value="找不到对应的客户"> </el-option>
                  </el-select>
                </base-input>
              </div>


              <div class="col-sm-3">
                <div style="column-gap: 5px; top: 30px"></div>
                <div class="row">
                  <div style="
                      column-gap: 5px;
                      text-align: right;
                      position: absolute;
                      bottom: 5px;
                    ">
                    <base-button type="primary" @click="search" style="width: 100px">Search</base-button>
                    <base-button type="primary" @click="resetConfig" style="width: 100px">Reset</base-button>
                  </div>
                </div>
              </div>
            </div>


            <hr />



            <!-- end Search part-->
            <div class="row" style="margin-top: 20px">

              <div class="col-sm-12" style="display: flex">
                <div class="col-sm-3">
                  <base-button type="danger" @click="PushContractInvoiceDataToEASFinance()"
                    style="width: 100px; margin-left: -15px">Send</base-button>
                </div>
                <span style="
                    margin-left: auto;
                    line-height: 32px;
                    padding-right: 20px;
                  ">
                  <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize"
                    :page-sizes="[10, 20, 30]" :small="small" :background="true"
                    layout="total, sizes, prev, pager, next, jumper" :total="searchKey.total"
                    @size-change="ChangePageSearchConfig" @current-change="ChangePageSearchConfig" />
                </span>

              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <el-table :data="Datalist" style="width: 100%" border header-row-class-name="header-row" row-key="id"
                  @selection-change="handleSelectionChange" @filter-change="search" table-layout="auto"
                  cell-class-name="report-cell" :row-class-name="rowClassName">
                  <el-table-column type="selection" width="55" />
                  <el-table-column prop="dcName" label="DcName" :width="90" />
                  <el-table-column prop="contentNumber" label="InvoiceNo" :width="200" />
                  <el-table-column prop="result" label="Result" :width="120" />
                  <el-table-column prop="message" label="Message" />
                  <el-table-column prop="remark" label="Remark" :width="320" />
                  <el-table-column prop="cteateDate" :formatter="formatterCellDateTime" label="CreateDate"
                    :width="180" />
                  <el-table-column prop="" fixed="right" label="Action" class-name="action" :width="120">
                    <template #default="scope">
                      <el-link v-if="scope.row.isParent" type="primary"
                        @click="PushDataToEAS(scope.row.contentNumber)">Send</el-link>
                      <el-link v-if="scope.row.isParent" style="margin-left: 20px;" type="primary"
                        @click="PushDataToFixed(scope.row.contentNumber)">Fixed</el-link>
                    </template>
                  </el-table-column>
                </el-table>
                <div></div>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </el-tab-pane>
</template>

<script setup>
import { watch, ref, reactive, onBeforeMount, onMounted } from 'vue';
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import tablecolumn from '@/components/tablecolumn';
import PubSub from 'pubsub-js';
import dateJs from '@/assets/js/date.js';

const currentPage = ref(1);
const pageSize = ref(10);
import { useAuthorityStore } from '@/store/authority';
const useAuthority = useAuthorityStore();
// router
import profile from '@/network/profile';

// icon
import { ElMessage, ElMessageBox } from 'element-plus';

// tool
import {
  formatterCellMoney,
  formatterCellDate,
  formatterCellDateTime,
} from '@/assets/js/formatter';
onBeforeMount(async () => {
  await search();
});

//#region Configs
const Datalist = ref([]);
const dcName = ref('');
const IsStarted = ref(false);
const dialogFormOpenUpdateConfig = ref(false);
const ConfigInfoData = reactive({});
const userlist = ref([]);
const SendData = reactive({
  SendInvoiceNumber: '',
  DateList: [
  ],
  DateList2: [
  ],
});
//是否隐藏复选框
const rowClassName = ({ row, rowIndex }) => {
  return row.isParent ? '' : 'hide-checkbox';
};
//勾选数据
const multipleSelection = ref([]);
const handleSelectionChange = async (val) => {
  multipleSelection.value = [];
  val.forEach(data => {
    if (multipleSelection.value.indexOf(data.contentNumber) == -1) { multipleSelection.value.push(data.contentNumber); }
  });
};
//变更分页
const ChangePageSearchConfig = async (data) => {
  searchKey.pageIndex = currentPage;
  searchKey.pageSize = pageSize;
  search();
};
const searchKey = reactive({
  pageIndex: 1,
  pageSize: 10,
  APIName: "Invoice",
  CreateDateList: [
    // `${dateJs.ConvertDate(new Date())}`,
    // `${dateJs.ConvertDate(new Date())}`,
  ],
  result: 'fail',
  SendDCName: 'hk',
  dcName: 'hk',
});

const search = async (isSend) => {
  const search_res = await profile
    .GetEASSendDataListFinance(searchKey)
    .then((res) => res);
  searchKey.total = search_res.data.total;
  Datalist.value = search_res.data.list;
};

const resetConfig = async () => {
  //清空对象
  Object.keys(searchKey).map((key) => {
    if (key != 'SendDCName') {
      delete searchKey[key];
    }
  });
  searchKey.pageIndex = 1;
  searchKey.pageSize = 10;
  searchKey.APIName = "Invoice";
  searchKey.dcName = "hk";
  searchKey.CreateDateList = [
    // `${dateJs.ConvertDate(new Date())}`,
    // `${dateJs.ConvertDate(new Date())}`,
  ];
  searchKey.result = '';
  search();
};

//数据推送到金蝶
const PushDataToEAS = async (InvoiceNumber) => {
  ElMessageBox.confirm('Are you sure to sync <<' + InvoiceNumber + '>> to Kingdee?', 'Warning [' + searchKey.SendDCName + ']', {
    confirmButtonText: 'OK',
    cancelButtonText: 'Cancel',
  })
    .then(async () => {
      const result = await profile.PushDataToEASInvoice({ InvoiceNumber: InvoiceNumber, SendDCName: searchKey.SendDCName }).then((res) => res);
      await search();
      if (result.data === '') {
        ElMessage({
          message: '操作成功',
          type: 'success',
        });
      } else {
        ElMessage({
          message: result.data,
          type: 'warning',
        });
      }
    })
    .catch(() => { });
};

const PushDataToFixed = async (contentNumber) => {
  ElMessageBox.prompt(`Are you sure selected (${contentNumber}) are fixed?`, 'Fixed Invoice [' + searchKey.SendDCName + ']', {
    confirmButtonText: 'OK',
    cancelButtonText: 'Cancel',
    inputErrorMessage: 'input is required',
    inputPattern: /.+/,
  })
    .then(async ({ value }) => {
      const result = await profile.FixedConttractInvoiceFinance({ ContractNo: contentNumber, ReturnData: value, APIName: "Invoice", SendDCName: searchKey.SendDCName }).then((res) => res);
      await search();
      if (result.data === '') {
        ElMessage({
          message: '操作成功',
          type: 'success',
        });
      } else {
        ElMessage({
          message: result.data,
          type: 'warning',
        });
      }
    })
    .catch(() => {

    })

};
//多选择数据推送到金蝶 Please select Invoice(s).
const PushContractInvoiceDataToEASFinance = async () => {
  if (multipleSelection.value.length == 0) {
    ElMessage({
      message: 'Please select Invoice(s).',
      type: 'warning',
    });
    return;
  }
  ElMessageBox.confirm('Are you sure to sync multiple selected Invoice to Kingdee?', 'Warning [' + searchKey.SendDCName + ']', {
    confirmButtonText: 'OK',
    cancelButtonText: 'Cancel',
  })
    .then(async () => {
      const result = await profile.PushContractInvoiceDataToEASFinance({ ContentNumberList: multipleSelection.value, APIName: "Invoice", SendDCName: searchKey.SendDCName }).then((res) => res);
      await search();
      if (result.data === '') {
        ElMessage({
          message: '操作成功',
          type: 'success',
        });
      } else {
        ElMessage({
          message: result.data,
          type: 'warning',
        });
      }
    })
    .catch(() => { });
};

//#endregion

//组件传值
onMounted(async () => {
  PubSub.subscribe('mode', (name, data) => {
    searchKey[`${data.key}`] = data.value;
    search();
  });
});
</script>

<style scoped>
.el-button--text {
  margin-right: 15px;
}

.el-select {
  width: 300px;
}

.el-input {
  width: 300px;
}

.dialog-footer button:first-child {
  margin-right: 10px;
}
</style>

<style>
/* 不显示复选框 */
.el-table .hide-checkbox .el-checkbox__input {
  display: none;
}
</style>